import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tabs } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { useAppStore } from '../../stores';
import DocumentPreview from '../DocumentPreview';
import './InputPackagesPreview.less';

const InputPackagesPreview: React.FC = () => {
    const { sessionStore } = useAppStore();

    // Lifehack to make Kendo UI spreadsheet fit the new height (when detached window is opened/closed).
    React.useEffect(() => {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }, [sessionStore.detachedWindow]);

    // Create tab panes for each input package
    const tabPanes = React.useMemo(() => {
        if (!sessionStore.response?.inputPackages) {
            return [];
        }

        let style: React.CSSProperties | undefined = undefined;
        if (sessionStore.detachedWindow) {
            style = { height: 'calc(100vh - 292px)', width: '100%' };
        }

        return sessionStore.response.inputPackages.map(pkg => (
            <Tabs.TabPane
                key={pkg.id}
                tab={
                    <>
                        <FileOutlined />
                        {pkg.name}
                    </>
                }
                className="input-package-tab-pane"
            >
                <DocumentPreview packageId={pkg.id} packageName={pkg.name} sheetsbar style={style} />
            </Tabs.TabPane>
        ));
    }, [sessionStore.response, sessionStore.detachedWindow]);

    if (!tabPanes.length) {
        return null;
    }

    return (
        <div className="input-packages-preview">
            <Tabs>{tabPanes}</Tabs>
        </div>
    );
};

export default observer(InputPackagesPreview);
